import  { HANDLE_COMMON } from "../actions";

const initialState = {
    userDetail: null
};

const customers = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_COMMON : 
            return {
                ...state,
                ...action.data
            }
        default:
            return state;
    }
}

export default customers;